<div class="banner" role="dialog" aria-modal="true">
  <eop-icon
    class="close-row"
    identifier="close"
    [clickable]="true"
    (click)="close()"
    (keydown.enter)="close()"
    genericButton
    [attr.aria-label]="'echargeBanner.a11y.close-banner' | translate"
  ></eop-icon>
  <div class="title">{{ 'echargeBanner.title' | translate }}</div>
  <div class="app-info">
    <div class="description">
      {{ 'echargeBanner.description' | translate }}
    </div>
  </div>
  <app-download-button (downloadClicked)="handleDownloadButtonClicked()" />
</div>
